// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N6Ai","left":"styles_left__1PtEB","desktopActions":"styles_desktopActions__3-KUH","title":"styles_title__v0fJy"};